import React from 'react'
import classNames from 'classnames'
import Container from '../container'
import Row from '../row'
import Col from '../col'
import { useUniqueIds } from '../../utilities/general'
import styles from './quote-columns.module.scss'
import shared from '../shared.module.scss'

const QuoteColumnsSlice = ({ slice }) => {
  const { items } = slice

  const {
    quote_columns_gutter,
    quote_columns_container_fluid,
    quote_columns_margin_bottom,
    quote_columns_text_color,
    quote_columns_background_color,
  } = slice.primary

  const itemsWithIds = useUniqueIds( items )

  return (
    <section
      className={ classNames( styles.section, quote_columns_margin_bottom ? shared.margin : '' ) }
      style={{ color: quote_columns_text_color, backgroundColor: quote_columns_background_color }}
    >
      <Container className={ styles.container } fluid={ quote_columns_container_fluid }>

        <Row gutter={ quote_columns_gutter } justify="center">
          { !! itemsWithIds.length && itemsWithIds.map( item => (
            <Col
              key={ item.uniqueId }
              span={ item.quote_columns_span }
              sm={ item.quote_columns_span_small }
              md={ item.quote_columns_span_medium }
              lg={ item.quote_columns_span_large }
              xl={ item.quote_columns_span_extra_large }
            >
              <p className={ styles.quote }>{ item.quote.text }</p>
              <p className={ styles.author }>{ item.author.text }</p>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}

export default QuoteColumnsSlice